module.exports = __webpack_public_path__ + "img/no-sabe.f95ffb03.png";